import { Box, type Theme, useTheme } from "@mui/material";

import FeaturesIcons from "./FeaturesIcons";

interface Feature {
  readonly id: number;
  readonly name: string;
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  item: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    gap: "8px",
    width: "130px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    height: "24px",
  },
  text: (isPropertyInfoCard: boolean) => ({
    color: (theme: Theme) => (isPropertyInfoCard ? theme.palette.common.white : theme.palette.text.primary),
    textTransform: "capitalize",
    fontSize: isPropertyInfoCard ? "14px" : "16px",
  }),
};

export default function FeaturesList({
  features,
  isPropertyInfoCard = false,
}: {
  features: Feature[];
  isPropertyInfoCard?: boolean;
}) {
  const theme = useTheme();
  const sortedFeature = features.toSorted((a, b) => a.name.localeCompare(b.name));
  return (
    <Box>
      <Box sx={styles.container}>
        {sortedFeature.map((item) => {
          const featureName = item.name.toLowerCase();
          const featureId = `feature_${item.id}`;
          return (
            <Box key={featureId} sx={styles.item}>
              <Box sx={styles.iconContainer}>
                <FeaturesIcons title={featureName} color={theme.palette.neutral[500]!} fontSize="16px" width="24px" />
              </Box>
              <Box sx={styles.text(isPropertyInfoCard)}>{item.name}</Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
